import './style.scss';
import React, { Component } from 'react';
import { MODAL_CARD_FORM, showModal } from '../../../../../../modules/modals';
import { connect } from 'react-redux';
import { deleteCard, getCategoriesUp, updateCard, setCartItemCopy, createCard } from '../../../../actions';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import { Switch, Modal as ModalAnt } from 'antd';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import 'react-photo-view/dist/react-photo-view.css';
import CardCopy from '../../../CardCopy/CardCopy';
import { FaRegCopy } from "react-icons/fa";

export class Item extends Component {
  static contextTypes = {formatMessage: PropTypes.any};
  constructor(props) {
    super(props)
    this.state = {
      spinner: true,
      modal: false,
      modal_copy: false,
    }
  }
  render() {
    const {formatMessage} = this.context;
    const {item, showModal, deleteCard, updateCard, getCategoriesUp, subject_selcted, categories, setCartItemCopy, itemCopy, createCard} = this.props;
    const { modal, modal_copy } = this.state;

    let subject_id = (categories.find(_i => _i.id == item.category_id) || {subject_id: ''}).subject_id;

    if(subject_id){
      subject_id = parseInt(subject_id)
    }
  
    return <div className='ItemCard'>
      <CardCopy 
        open={modal_copy}
        createCard={createCard}
        initialValues={itemCopy}
        onClose={() => {
          this.setState({modal_copy: false})
        }} />
      <Modal
        isOpen = {modal}
        style = {{
            overlay : {zIndex: 9999999},
        }}
        onRequestClose={() => {}}
        overlayClassName = "custom-modal"
        className = "custom-modal-content create-dialog-modal-content"
      >
        <div className="create-dialog-modal-content__header">
          <div className="create-dialog-modal-content__title">{formatMessage('msgTextCloseCardModalDelete')}</div>
        </div>
        <div className="create-dialog-modal-content__body">
          <div className="create-dialog-form form-quiz-create">
            <div className="col-xs-12 text-center word-wrap-break" style={{marginBottom: 10}}>{formatMessage('msgTextCardModalDelete')}</div>
            <div className="create-dialog-form__group flex">
              <button className="btn btn-primary" type="button" onClick={async () => {
                this.setState({modal: false})
                await deleteCard(item.id)
                if(subject_selcted && subject_selcted.id){
                  getCategoriesUp(subject_selcted.id)
                }
              }}>{formatMessage('Yes')}</button>
              <button className="btn btn-warning" type="button" onClick={() => this.setState({modal: false})}>{formatMessage('No')}</button>
            </div>
          </div>
          
        </div>
      </Modal>
      <div className='actions'>
        <div className='icon block-icon'>
          <Switch size="small" checked={item.is_show} onChange={() => {
            updateCard({...item, is_show: !item.is_show})
          }} />
        </div>
        <div className='icon' onClick={() => {
          showModal({
            modalType : MODAL_CARD_FORM,
            modalProps : {
              initialValues: {...item, subject_id},
            }
          });
        }}>
          <img src="/build/images/method-draw-image.svg" width="48" height="48"/>
        </div>
        <div className='icon block-icon' onClick={() => {
          const tmp = {
            subject_id,
            answer: item.answer,
            answer_img: item.answer_img,
            description: item.description,
            is_show: item.is_show,
            question: item.question,
            question_img: item.question_img,
            category_id: item.category_id,
          };

          if(itemCopy){
            if(itemCopy.category_id){
              tmp.category_id = itemCopy.category_id;
            }
  
            if(itemCopy.subject_id){
              tmp.subject_id = itemCopy.subject_id;
            }
          }
          setCartItemCopy(tmp)
          this.setState({modal_copy: true})
        }}>
          <FaRegCopy size={18} />
        </div>
        <div className='icon' onClick={() => {this.setState({modal: true})}}>
          <img src="/build/images/GarbageButton.svg?dd496e1175bddf2473114d4037e004a8" width="48" height="48"/>
        </div>
      </div>
      <div className='question'>
        {item.question_img && <PhotoProvider>
          <PhotoView src={item.question_img}>
            <div className='image'>
              <img src={item.question_img} />
              {Boolean(item.question_img_alt) && <div className='image_alt'>{item.question_img_alt}</div>}
            </div>
          </PhotoView>
        </PhotoProvider>}
        <div className='text'>
          <div style={{width: '100%'}} dangerouslySetInnerHTML={{__html: item.question}}/>
        </div>
      </div>
      <hr/>
      <div className='question'>
        {item.answer_img && <PhotoProvider>
          <PhotoView src={item.answer_img}>
            <div className='image'>
              <img src={item.answer_img} />
              {Boolean(item.answer_img_alt) && <div className='image_alt'>{item.answer_img_alt}</div>}
            </div>
          </PhotoView>
        </PhotoProvider>}
        <div className='text'>
          <div style={{width: '100%'}} dangerouslySetInnerHTML={{__html: item.answer}}/>
        </div>
      </div>
    </div>;
  }
}

const mapStateToProps = (state, ownProps) => ({
  subject_selcted: state.card.subject_selcted,
  subjects: state.card.subjects,
  categories: state.card.categories,
  itemCopy: state.card.itemCopy,
})

const mapDispatchToProps = {
  updateCard,
  showModal,
  deleteCard,
  getCategoriesUp,
  setCartItemCopy,
  createCard,
}

export default connect(mapStateToProps, mapDispatchToProps)(Item);




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Card/components/Cards/components/Item/Item.jsx